<template>
  <div class="form-inline">
    <label class="mr-2"><b>Bot-Status</b></label>
    <label class="mr-2">XMPP:</label>
    <font-awesome-icon v-if="status.xmpp && status.xmpp.ready" icon="toggle-on"/>
    <font-awesome-icon v-else icon="toggle-off"/>
    <label class="mr-2">Telegram:</label>
    <font-awesome-icon v-if="status.telegram && status.telegram.ready" icon="toggle-on"/>
    <font-awesome-icon v-else icon="toggle-off"/>
  </div>
</template>

<script>
import chatbot from '@/modules/chatbot.js'

export default {
  name: 'ChatBotStatus',
  data() {
    return {
      status: {},
      updateiv: false,
    }
  },
  mounted: function() {
    this.updateStatus();
    this.updateiv = setInterval(this.updateStatus.bind(this), 3000);
  },
  beforeDestroy: function() {
    if (this.updateiv) {
      clearInterval(this.updateiv);
    }
  },
  methods: {
    updateStatus: function() {
      var self = this;
      chatbot.status(this,function(data) {
        self.status = data;
      })
    },
  }
}
</script>
